import { render, staticRenderFns } from "./CrewLabors.vue?vue&type=template&id=538c7464"
import script from "./CrewLabors.vue?vue&type=script&lang=js"
export * from "./CrewLabors.vue?vue&type=script&lang=js"
import style0 from "./CrewLabors.vue?vue&type=style&index=0&id=538c7464&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports